export class KakaoAuth {
  clientId: string;
  restApiKey: string;
  callbackURL: string;

  constructor(clientId: string, restApiKey: string, callbackURL: string) {
    this.clientId = clientId;
    this.restApiKey = restApiKey;
    this.callbackURL = callbackURL;
  }

  createScriptTag() {
    const script = document.createElement('script');
    script.id = KakaoAuth.scriptId;
    script.src = KakaoAuth.scriptSrc;
    script.defer = true;
    script.async = true;
    script.onload = () => {
      if (!(window as any).Kakao) {
        throw new Error('Error: kakao script is not installed properly');
      }

      (window as any).Kakao.init(this.clientId);
    };
    return script;
  }

  userLogin() {
    (window as any).Kakao.Auth.authorize({
      redirectUri: this.callbackURL,
      throughTalk: !(typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)),
    });
  }

  static getKakaoAccessToken({ redirectUri, code, clientId }: { redirectUri: string; code: string; clientId?: string }) {
    return fetch(`https://kauth.kakao.com/oauth/token?grant_type=authorization_code&client_id=${clientId}&redirect_uri=${redirectUri}&code=${code}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    }).then((res) => {
      if (!res.ok) throw res;
      return res.json();
    });
  }

  static get scriptSrc() {
    return 'https://developers.kakao.com/sdk/js/kakao.min.js';
  }

  static get scriptId() {
    return 'kakao-login-sdk';
  }
}
